module.exports = __webpack_public_path__ + "static/img/wb_banner.ad0740d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jieju/wb_banner.png
// module id = eKSf
// module chunks = 1